import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  private imageTarget: HTMLImageElement

  connect() {
    // Add double-click event listener
    this.imageTarget.addEventListener('dblclick', this.toggleFullscreen.bind(this))
  }

  disconnect() {
    // Clean up event listener
    this.imageTarget.removeEventListener('dblclick', this.toggleFullscreen.bind(this))
  }

  async toggleFullscreen() {
    if (!document.fullscreenElement) {
      try {
        await this.imageTarget.requestFullscreen()
      } catch (err) {
        console.error(`Error attempting to enable fullscreen: ${err.message}`)
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
  }
}
